/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetContactDetailsRequest
 */
export interface SetContactDetailsRequest {
    /**
     * Primary admin email address for security notifications.
     */
    email?: string;
    /**
     * Full name of the emergency contact person.
     */
    name?: string;
    /**
     * Phone number of the emergency contact.
     */
    phone?: string;
}

/**
 * Check if a given object implements the SetContactDetailsRequest interface.
 */
export function instanceOfSetContactDetailsRequest(value: object): value is SetContactDetailsRequest {
    return true;
}

export function SetContactDetailsRequestFromJSON(json: any): SetContactDetailsRequest {
    return SetContactDetailsRequestFromJSONTyped(json, false);
}

export function SetContactDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetContactDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function SetContactDetailsRequestToJSON(json: any): SetContactDetailsRequest {
    return SetContactDetailsRequestToJSONTyped(json, false);
}

export function SetContactDetailsRequestToJSONTyped(value?: SetContactDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'phone': value['phone'],
    };
}

